import React, { useEffect, useMemo, useState, useContext, useCallback } from 'react';
import { MantineReactTable, useMantineReactTable } from 'mantine-react-table';
import {
  Button,
  Card,
  Container,
  Group,
  Title,
  ActionIcon,
  Tooltip,
  Modal,
  Text,
} from '@mantine/core';
import { FaArrowLeft, FaEdit, FaTrash } from 'react-icons/fa';
import StudentDetailsForm from '../forms/StudentDetailsForm';
import './Branches.css';
import axios, {
  addStudentDetails,
  deleteStudent,
  editStudentDetails,
  getStudentDetails,
} from '../../axios';
import authContext from '../../AuthContext';
import imageBaseURL from '../../image';
import { useLocation } from 'react-router-dom';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import { getStudentDetailsByBatchId } from '../../axios';
import ExportExcel from '../ExportExcel'
import placeholder from '../../assets/placeholder.png'
import ExportDoc from '../ExportDoc';
import ExportPdf from './ExportPdf'
const StudentDetails = () => {
  const location = useLocation();
  const batchId = location.state?.batchId || null;
  const isBatchStudent = location.state?.isBatchStudent || false;
  const [showForm, setShowForm] = useState(false);
  const [data, setData] = useState([]);
  const [editStudent, setEditStudent] = useState(null);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [studentToDelete, setStudentToDelete] = useState(null);
  const { user, userType } = useContext(authContext);
  const [update, setUpdate] = useState(false);

const exportPDF = async (rows) => {
  const doc = new jsPDF('p', 'mm', 'a4');
  const tableHeaders = ['Sr.No.', 'Name', 'Batch Code', 'Photo 1', 'Created At'];

  // Enhanced toBase64 with upscaling and fallback
 const toBase64 = async (url) => {
  const upscaleImage = (img) => {
    return new Promise((resolve) => {
      const scaleFactor = 2;
      const canvas = document.createElement('canvas');
      canvas.width = img.width * scaleFactor;
      canvas.height = img.height * scaleFactor;

      //console.log(`Original size: ${img.width} x ${img.height}`);
      //console.log(`Enhanced size: ${canvas.width} x ${canvas.height}`);

      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      resolve(canvas.toDataURL('image/jpeg', 1.0));
    });
  };

  const loadImage = (src) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = () => resolve(img);
      img.onerror = reject;
      img.src = src;
    });
  };

  try {
    const img = await loadImage(url);
    return await upscaleImage(img);
  } catch (err) {
    console.warn(`Image failed to load: ${url}, using placeholder`);
    try {
      const fallbackImg = await loadImage(placeholder);
      return await upscaleImage(fallbackImg);
    } catch (e) {
      console.error('Placeholder image also failed to load:', e);
      return null;
    }
  }
};


  const bodyData = [];
  const imageData = [];
  const rowHeights = [];

  for (let i = 0; i < rows.length; i++) {
    const student = rows[i].original || rows[i];
    const imgUrl = student.photo1
      ? `https://ppxxub.online/apis/image-proxy.php?name=${student.photo1}`
      : placeholder;

    const imgBase64 = await toBase64(imgUrl);
    imageData.push(imgBase64);

    // Estimate row height based on image
    let height = 30;
    if (imgBase64) {
      try {
        const imgProps = doc.getImageProperties(imgBase64);
        const mmHeight = imgProps.height * 0.264583;
        height = Math.min(mmHeight + 8, 60);
      } catch {
        height = 30;
      }
    }

    rowHeights.push(height);

    bodyData.push([
      i + 1,
      student.name || 'N/A',
      student.batch_code || 'N/A',
      '', // image placeholder
      student.created_at ? new Date(student.created_at).toLocaleString() : 'N/A',
    ]);
  }

  autoTable(doc, {
    head: [tableHeaders],
    body: bodyData,
    startY: 10,
    rowPageBreak: 'avoid',
    styles: {
      fontSize: 10,
      valign: 'middle',
      halign: 'center',
      overflow: 'linebreak',
    },
    headStyles: {
      fillColor: [44, 122, 59],
      textColor: 255,
      fontStyle: 'bold',
    },
    columnStyles: {
      0: { cellWidth: 15 },
      1: { cellWidth: 45, halign: 'left' },
      2: { cellWidth: 30 },
      3: { cellWidth: 60 }, // Image cell
      4: { cellWidth: 40, halign: 'left' },
    },
    willDrawCell: (data) => {
      if (data.section === 'body') {
        data.row.height = rowHeights[data.row.index] || 30;
        data.cell.height = data.row.height;
      }
    },
    didDrawCell: (data) => {
      const colIndex = data.column.index;
      const rowIndex = data.row.index;

      if (data.section === 'body' && colIndex === 3 && imageData[rowIndex]) {
        try {
          const img = imageData[rowIndex];
          const imgProps = doc.getImageProperties(img);
          const pxToMm = (px) => px * 0.264583;

          let width = pxToMm(imgProps.width);
          let height = pxToMm(imgProps.height);

          const maxW = data.cell.width - 4;
          const maxH = data.cell.height - 4;

          if (width > maxW) {
            const scale = maxW / width;
            width *= scale;
            height *= scale;
          }
          if (height > maxH) {
            const scale = maxH / height;
            width *= scale;
            height *= scale;
          }

          const x = data.cell.x + (data.cell.width - width) / 2;
          const y = data.cell.y + (data.cell.height - height) / 2;

          doc.addImage(img, imgProps.fileType || 'JPEG', x, y, width, height);
        } catch (error) {
          console.error(`Image rendering error at row ${rowIndex}:`, error);
          doc.text('No Image', data.cell.x + 2, data.cell.y + 10);
        }
      }
    },
  });

  doc.save('Student-details.pdf');
};


  const fetchStudentsByBatch = async () => {
    try {
      const response = await getStudentDetailsByBatchId(batchId);
      //console.log(response.data);
      setData(response.data);
    } catch (error) {
      console.error('Error fetching batch student data:', error);
    }
  };

  const fetchStudents = async () => {
    try {
      const response = await getStudentDetails(user);
      //console.log(user)
      setData(response.data);
    } catch (error) {
      console.error('Error fetching student data:', error);
    }
  };

useEffect(() => {
  if (!user) return; // Don't call until user is loaded

  if (isBatchStudent && batchId) {
    fetchStudentsByBatch();
  } else {
    fetchStudents();
  }
}, [update, user, isBatchStudent, batchId]);
//console.log(update)
  const handleAddStudent = async (student) => {
    try {
      if (editStudent) {
        //console.log('Editing student:', student);
        const res = await editStudentDetails(student);
        //console.log(res)
          setUpdate(!update);
          setShowForm(false);
          setEditStudent(null);
      } else {
        const res = await addStudentDetails(student);
        if (res.status === 200) {
          setUpdate(!update);
          setShowForm(false);
          setEditStudent(null);
        }
      }
    } catch (error) {
      console.error('Error adding/editing student:', error);
    }
  };

  const handleEdit = useCallback((row) => {
    setEditStudent(row.original);
    setShowForm(true);
  }, []);

  const handleDelete = useCallback((row) => {
    setStudentToDelete(row.original);
    setConfirmDelete(true);
  }, []);

  const confirmDeleteStudent = async () => {
    if (studentToDelete) {
      try {
        const res = await deleteStudent(studentToDelete.id);
        if (res.status === 200) {
          setUpdate(!update);
          setConfirmDelete(false);
          setStudentToDelete(null);
        }
      } catch (error) {
        console.error('Error deleting student:', error);
      }
    }
  };

  const columns = useMemo(
    () => [
      { accessorKey: 'serial_number', header: 'Sr.No.', size:100, Cell: ({ row }) => row.index + 1 },
      { accessorKey: 'name', header: 'Name',size: 150  },
      { accessorKey: 'batch_code', header: 'Batch Code' ,size: 180 },
      {
        accessorKey: 'photo1',
        header: 'Photo 1',
        size: 200,
        Cell: ({ cell }) => (
          <img
            src={`https://ppxxub.online/apis/${cell.getValue()}`}
            alt="Photo1"
            style={{ width: 180, height: 100, objectFit: 'cover', borderRadius: '8px' }}
            onError={(e) => {
              e.target.onerror = null; // Prevent infinite loop
              e.target.src = placeholder; // Fallback image
              console.warn(`Failed to load image: ${cell.getValue()}`);
            }}
          />
        ),
        
      },
      {
        accessorKey: 'created_at',
        header: 'Created At',
        size: 200,
        Cell: ({ cell }) => new Date(cell.getValue()).toLocaleString(),
        
      },
      ...(userType === 'sa'
        ? [
            {
              accessorKey: 'actions',
              header: 'Actions',
              Cell: ({ row }) => (
                <Group spacing="xs">
                  <Tooltip label="Edit Student">
                    <ActionIcon color="green" variant="light" onClick={() => handleEdit(row)}>
                      <FaEdit size={16} />
                    </ActionIcon>
                  </Tooltip>
                  <Tooltip label="Delete Student">
                    <ActionIcon color="red" variant="light" onClick={() => handleDelete(row)}>
                      <FaTrash size={16} />
                    </ActionIcon>
                  </Tooltip>
                </Group>
              ),
            },
          ]
        : []),
    ],
    [userType, handleEdit, handleDelete]
  );

  const table = useMantineReactTable({ columns, data });

  return (
    <Container size="lg" style={{ marginTop: '20px', padding: '20px' }}>
      {showForm ? (
        <>
          <Group mb="md">
            <ActionIcon variant="outline" color="gray" onClick={() => setShowForm(false)}>
              <FaArrowLeft size={16} />
            </ActionIcon>
          </Group>
          <StudentDetailsForm onSubmit={handleAddStudent} student={editStudent} />
        </>
      ) : (
        <>
          <Group position="apart" mb="md">
            <Title order={2} style={{ color: '#2c7a3b' }}>
              Student List
            </Title>
            <Group spacing="xs">
              <Button
                color="red"
                variant="outline"
                onClick={() => exportPDF(table.getRowModel().rows)}
              >
                Export PDF
              </Button>
              <ExportDoc data={data} />
              <ExportExcel data={data} />
              <Button color="green" variant="outline" onClick={() => setShowForm(true)}>
                Add Student
              </Button>
            </Group>
          </Group>
          <Card withBorder shadow="sm" radius="md" p="md">
            <MantineReactTable table={table} />
          </Card>
        </>
      )}

      <Modal
        opened={confirmDelete}
        onClose={() => setConfirmDelete(false)}
        centered
        size="sm"
        title="Confirm Deletion"
        overlayProps={{ opacity: 0.5, blur: 3 }}
      >
        <Text>Do you want to delete {studentToDelete?.name}?</Text>
        <Group position="right" mt="md">
          <Button variant="outline" onClick={() => setConfirmDelete(false)}>
            Cancel
          </Button>
          <Button color="red" onClick={confirmDeleteStudent}>
            Confirm
          </Button>
        </Group>
      </Modal>
    </Container>
  );
};

export default StudentDetails;